import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: true
}

const homeVisibilitySlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        show: (state) => {
            state.value = true;
        },
        hide: (state) => {
            state.value = false;
        }
    }
})

export const { show, hide } = homeVisibilitySlice.actions;
export default homeVisibilitySlice.reducer